var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18c-1.105 0-2-.796-2-1.778V3.778C4 2.796 4.895 2 6 2s2 .796 2 1.778v12.444C8 17.204 7.105 18 6 18ZM14 18c-1.105 0-2-.796-2-1.778V3.778C12 2.796 12.895 2 14 2s2 .796 2 1.778v12.444c0 .982-.895 1.778-2 1.778Z"
  })));
};
export default SvgPause;